import { render, staticRenderFns } from "./GsCalendarItem.vue?vue&type=template&id=5f3ab7d8&scoped=true&"
import script from "./GsCalendarItem.vue?vue&type=script&lang=js&"
export * from "./GsCalendarItem.vue?vue&type=script&lang=js&"
import style0 from "./GsCalendarItem.vue?vue&type=style&index=0&id=5f3ab7d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3ab7d8",
  null
  
)

export default component.exports